import { isMobile } from 'react-device-detect';


export const COLORS = ['#EA4335', '#34A853', '#4285F4', '#FBBC05', '#EA4335', '#34A853'];

export const SIZES_DESKTOP = [75, 75, 75, 75, 75, 75, 75, 75, 75, 75];

export const SIZES_MOBILE = [50, 50, 50, 50, 50, 50, 50, 50, 50, 50];

export const SCORES = [10, 25, 50, 100, 200, -10, -25, -50, -100, -200];

export const SYMBOLS_RARE = [13, 17, 18];

export const RARE_SCORES = [1000, -1000, 10];

export const SYMBOLS_DESKTOP = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const SYMBOLS_MOBILE = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const SPEED_STEP = 50;

export const MAX_POINTS = 50;

export const SPAWN_INTERVAL = 500;
